import { Controller, useForm } from "react-hook-form";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { investigationForm } from "./fieldData";
import {
  Button,
  CircularProgress,
  InputAdornment,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { ChangeEvent, FC, useContext, useEffect, useRef, useState } from "react";
import { getPatientShare, getRateOfCpt } from "../../services";
import { LabContext, contextType } from "./Lab/LabComponent";
import {
  // CptInvestigationRateType,
  investigationDefaultValues,
  InvestigationDropDownType,
  InvestigationFormType,
  LabType,
  prepareLabPayload,
  prepareRadiologyPayload,
  RadiologyType,
} from "./types";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import usePopup from "../../../hooks/usePopup";
import { FormOnChangeEventType } from "../../types";
import debounce from "../../../utilis/methods/networkHandling";
import { RadiologyContext } from "./Radiology/Radiology";
import { EmrContext } from "../..";
import useActivitySearch from "../hook/useActivitySearch";
import useSaveActivity from "../hook/useSaveActivity";
import CustomDateField from "../CustomDateField";
import dayjs from "dayjs";
import PercentIcon from "@mui/icons-material/Percent";
import useCptFavourite from "../hook/useCptFavourite";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import useAuthentication from "@hooks/useAuthentication";
import moment from "moment";
// let isFetchRate = false;
const InvestigationForm: FC<{
  close?: () => void;
  formType: "lab" | "radiology";
}> = ({ close, formType }) => {
  const { encounterId } = useParams();
  const { patientData, page, triggerConsultationStart } = useContext(EmrContext);
  const { user } = useAuthentication();
  const activitySearchUserId =
    Number(user?.userId ?? user?.login_id) || null;
  const { control, handleSubmit, reset, getValues, setValue, watch, clearErrors} = useForm({
    defaultValues: investigationDefaultValues as any,
  });
  const { CustomModal, showSnackbar } = usePopup();
  const [show, setShow] = useState(false);
  const insDiscount = useRef(0);
  const [checkboxChecked, setCheckboxChecked] = useState<{
    approval: boolean;
    exclude: boolean;
  }>({
    approval: false,
    exclude: false,
  });
  const selectedCpt = watch(investigationForm.cptItem.name);
  const fromVerification = Boolean(page == "verification");
  const [isManualCoverage, setIsManualCoverage] = useState<number>(0);
  // const [rateDetails, setRateDetails] = useState<CptInvestigationRateType>({
  //   approvalRequired: null,
  //   cptGroupID: null,
  //   cptId: null,
  //   cptName: null,
  //   insRate: null,
  //   isExcluded: null,
  // });
  const { edit, setEdit, setRefetchLab } = useContext(
    LabContext,
  ) as contextType;
  const {
    tableData: radiologyTable,
    edit: radiologyEdit,
    setEdit: setRadiologyEdit,
    setRefechRadiology,
  } = useContext(RadiologyContext);

  const { mutate: fetchPatientShare, isLoading: fetchPatientShareLoading } =
    useMutation(getPatientShare, {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          insDiscount.current = Number(result.response?.insDiscount || 0);
          const discountType = getValues("discountType") || "Percentage";
          let discount = Number(getValues("discount") || "0");
          let patShare = Number(result.response?.patShare || "0");

          if (discount < 0) {
            discount = 0;
            setValue("discount", 0);
          } else if (discountType === "Percentage" && discount > 100) {
            discount = 100;
            setValue("discount", 100);
          } else if (discountType === "Amount" && patShare > 0 && discount > patShare) {
            discount = patShare;
            setValue("discount", patShare);
          }
          clearErrors("discount");

          if (discountType == "Percentage") {
            patShare = patShare - (Number(patShare) * Number(discount)) / 100;
          }else{
            patShare = Number(patShare) - Number(discount);
            patShare = patShare < 0 ? 0 : patShare;
          }
          console.log(patShare,"patShare")
          setValue(
            investigationForm.patientShare.name,
            Number(patShare || 0).toFixed(2),
          );
          setValue(
            investigationForm.amount.name,
            result.response?.insAmount || "0",
          );
        }
      },
    });

  const { mutate: fetchRate, isLoading: fetchRateLoading } = useMutation(
    getRateOfCpt,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success" && result.response) {
          if (result?.response?.insRate != null) {
            // const roundedRate = Number(result.response.insRate).toFixed(2);
            setValue(
              investigationForm.Rate.name,
              Number(result.response.insRate) || "0",
            );
          } else {
            setValue(investigationForm.Rate.name, "");
            !fromVerification &&
              showSnackbar({
                message: "Something went wrong !",
                open: true,
                variant: "warning",
                duration: 2000,
              });
          }
        } else {
          setValue(investigationForm.Rate.name, "");
          showSnackbar({
            message: "Something went wrong !",
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
    },
  );

  const {
    mutate: searchActiviy,
    data: dropdowData,
    isLoading: activityLoading,
  } = useActivitySearch();

  const {
    cptListOpen,
    setCptListOpen,
    renderCptOptionListItem,
  } = useCptFavourite({ cptOptions: dropdowData?.response });

  const getInvestigationGroupId = () => {
    if (formType === "radiology") return 1;
    if (formType === "lab") return 2;
    return 0;
  };

  const buildActivitySearchParams = (searchText: string) => ({
    searchText,
    encounterId: parseInt(encounterId as string),
    groupId: getInvestigationGroupId(),
    poID: patientData.postOffice.postofficeId,
    userId: activitySearchUserId,
    codetype: String(user?.codetype),
    insname: String(patientData?.insurancePatient?.insurance_name || ""),
  });

  const resultHandle = {
    onSuccess: (result: any) => {
      if (result?.responseIndicator == "success") {
        setCheckboxChecked({
          approval: false,
          exclude: false,
        });
        reset({
          defaultValues: investigationDefaultValues,
        });
        showSnackbar({
          message: result?.responseMessage,
          open: true,
          variant: "success",
        });
        triggerConsultationStart();
        if (Boolean(edit)) {
          setEdit(null);
        }
        if (Boolean(radiologyTable)) {
          setRadiologyEdit(null);
        }

        if (formType == "lab") {
          setRefetchLab(true);
        }

        if (formType == "radiology") {
          setRefechRadiology(true);
        }
        searchActiviy(buildActivitySearchParams(""));
        setIsManualCoverage(0);
      } else {
        showSnackbar({
          message: result?.responseMessage,
          open: true,
          variant: "warning",
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "warning",
      });
    },
  };

  const { mutate: saveActivity, isLoading: activitySaveLoading } =
    useSaveActivity(resultHandle);

  const calculatePatientShare = (params: {
    amount: number;
    cptId: number;
    qty: number;
    cptGroupId: number;
  }) => {
    if (Boolean(edit) || Boolean(radiologyEdit)) {
      Boolean(edit) &&
        fetchPatientShare({
          ...params,
          encounter: parseInt(encounterId as string),
          editFlag: 1,
          id: edit?.radiologyId as number,
        });

      Boolean(radiologyEdit) &&
        fetchPatientShare({
          ...params,
          encounter: parseInt(encounterId as string),
          editFlag: 1,
          id: radiologyEdit?.radiologyId as number,
        });
    } else {
      fetchPatientShare({
        ...params,
        encounter: parseInt(encounterId as string),
        editFlag: 0,
        id: 0,
      });
    }
  };

  const calculateRate = () => {
    const allValues = getValues() as InvestigationFormType;
    const cpt = allValues.cpt as InvestigationDropDownType;
    const quantity = Number(allValues.Quantity || "0");
    const rate = Number(`${allValues.Rate || "0"}`);
    let discount = Number(allValues.discount || "0");
    const discountType = allValues.discountType || "Percentage";
    let total = rate * quantity;
    const originalTotal = total;

    if (discount < 0) {
      discount = 0;
      setValue("discount", 0);
    } else if (discountType === "Percentage" && discount > 100) {
      discount = 100;
      setValue("discount", 100);
    } else if (discountType === "Amount" && total > 0 && discount > total) {
      discount = total;
      setValue("discount", total);
    }
    clearErrors("discount");

    if (discountType == "Percentage") {
      total = total - (total * discount) / 100;
    } else {
      total = total - discount;
      total = total < 0 ? 0 : total
    }
    if (patientData.pmaster.paymentMode == 0 || allValues.isExcluded) {
      setValue(investigationForm.amount.name, originalTotal.toString());
      setValue(investigationForm.patientShare.name, Number(total || 0).toFixed(2));
    } else {
      if (cpt.insCoverage == 0) {
        setValue(investigationForm.amount.name, originalTotal.toString());
        setValue(investigationForm.patientShare.name, Number(total || 0).toFixed(2));
      } else {
        if (quantity) {
          calculatePatientShare({
            amount: rate,
            cptGroupId: cpt.cptGroupId,
            cptId: cpt.cptId,
            qty: quantity,
          });
        } else {
          setValue(investigationForm.amount.name, "");
          setValue(investigationForm.patientShare.name, "");
        }
      }
    }
  };

  const onChange = (e: FormOnChangeEventType) => {
    const { name, value } = e.target;

    if (name == investigationForm.cptItem.name) {
      setValue(investigationForm.isExcluded.name, value?.isExclude);
      setValue(
        investigationForm.approvalRequired.name,
        value?.approvalRequired,
      );
      setValue(investigationForm.Quantity.name, "");
      setValue(investigationForm.patientShare.name, "0.00");
      setValue(investigationForm.amount.name, "0");
      setValue(
        investigationForm.insuranceCoverage.name,
        Boolean(value.insCoverage == 1),
      );
      // isFetchRate = false;
      const { isExcluded } = getValues() as InvestigationFormType;
      if (
        patientData.pmaster.paymentMode == 1 &&
        value.insCoverage == 1 &&
        !isExcluded
      ) {
        isManualCoverage == 1;
        fetchRate({
          cptId: value.cptId,
          encounter: parseInt(encounterId as string),
          cptGroupId: value.cptGroupId,
          paymentMode: patientData.pmaster.paymentMode,
        });

        setCheckboxChecked({
          approval: !Boolean(value.insCoverage),
          exclude: !Boolean(value.insCoverage),
        });
      } else {
        setShow(Boolean(patientData.pmaster.paymentMode == 1));
        Boolean(patientData.pmaster.paymentMode == 0) &&
          setValue(
            investigationForm.Rate.name,
            `${e.target.value.cptRate || "0"}`,
          );
      }
      setIsManualCoverage(Number(value.insCoverage));
    }
    if (
      name == investigationForm.Rate.name ||
      name == investigationForm.Quantity.name || name == "discount" || name == "discountType"
    ) {
      calculateRate();
    }
  };

  const handleExcludeChange = (e: FormOnChangeEventType) => {
    const { value } = e.target;
    const allValues = getValues() as InvestigationFormType;
    if (allValues.cpt) {
      setCheckboxChecked({
        approval: value,
        exclude: false,
      });
      if (value) {
        setShow(true);
        setValue(investigationForm.approvalRequired.name, false);
        if (fromVerification) {
          reset({
            ...allValues,
            // [investigationForm.Rate.name]: radiologyEdit?.cpt?.cptRate || 0,
            // [investigationForm.Quantity.name]: "",
            // [investigationForm.patientShare.name]: "",
            // [investigationForm.amount.name]: "",
            // [investigationForm.insuranceCoverage.name]: 0,
            [investigationForm.isExcluded.name]: true,
            [investigationForm.approvalRequired.name]: false,
          });
        } else {
          reset({
            ...allValues,
            // [investigationForm.Rate.name]: radiologyEdit?.cpt?.cptRate || 0,
            // [investigationForm.Quantity.name]: "",
            // [investigationForm.patientShare.name]: "",
            // [investigationForm.amount.name]: "",
            [investigationForm.isExcluded.name]: true,
            [investigationForm.approvalRequired.name]: false,
          });
        }
      } else {
        setShow(false);
        reset({
          ...allValues,
          [investigationForm.Quantity.name]: "",
          [investigationForm.patientShare.name]: "",
          [investigationForm.amount.name]: "",
        });
        if (allValues.cpt.insCoverage || allValues.insuranceCoverage) {
          // !fromVerification &&
          isManualCoverage == 1 &&
            fetchRate({
              cptGroupId: allValues.cpt.cptGroupId,
              cptId: allValues.cpt.cptId,
              encounter: parseInt(encounterId || "0"),
              paymentMode: patientData.pmaster.paymentMode,
            });
          setValue(
            investigationForm.approvalRequired.name,
            allValues.cpt.approvalRequired,
          );
        } else {
          reset({
            ...allValues,
            [investigationForm.isExcluded.name]: false,
            [investigationForm.Rate.name]: allValues.cpt.cptRate || "0",
          });
        }
      }
    } else {
      setValue(investigationForm.isExcluded.name, false);
      showSnackbar({
        message: "Please select a CPT Code !",
        open: true,
        variant: "info",
        duration: 3000,
      });
    }
  };

  const handleApprovalChange = (e: FormOnChangeEventType) => {
    const { value } = e.target;
    setCheckboxChecked({
      approval: false,
      exclude: value,
    });
    if (value) {
      setValue(investigationForm.isExcluded.name, false);
    }
  };

  const handlefetchRate = () => {
    const cpt = getValues(investigationForm.cptItem.name);
    setValue(investigationForm.Rate.name, cpt?.cptRate);
    setShow(false);
  };

  const handleYesClick = () => {
    const allData = getValues();
    handlefetchRate();
    setCheckboxChecked({
      approval: true,
      exclude: false,
    });
    reset({
      ...allData,
      [investigationForm.Rate.name]: allData?.cpt?.cptRate || 0,
      [investigationForm.approvalRequired.name]: false,
      [investigationForm.Quantity.name]: "",
      [investigationForm.patientShare.name]: "",
      [investigationForm.amount.name]: "",
      // [investigationForm.isExcluded.name]: getValues(
      //   investigationForm.cptItem.name
      // )?.insCoverage
      //   ? true
      //   : false,
    });
  };

  const onsubmit = (data: any) => {
    const computeActualPatShare = (
      patientShareAfterDiscount: unknown,
      discountRaw: unknown,
      discountTypeRaw: unknown,
    ) => {
      const after = Number(patientShareAfterDiscount || 0);
      const discount = Number(discountRaw || 0);
      const discountType = String(discountTypeRaw || "Percentage").toLowerCase();

      if (discountType === "percentage") {
        const pct = Math.min(Math.max(discount, 0), 100);
        const denom = 1 - pct / 100;
        if (denom <= 0) return 0;
        const base = after / denom;
        return Number.isFinite(base) ? Number(base.toFixed(2)) : 0;
      }

      // Amount
      const base = after + Math.max(discount, 0);
      return Number.isFinite(base) ? Number(base.toFixed(2)) : 0;
    };

    const actualPatshare = computeActualPatShare(
      data?.patientshare,
      data?.discount,
      data?.discountType,
    );

    let params: {
      fromVerification?: boolean;
      radiologyDetailsDto?: RadiologyType;
      labDetailsDto?: LabType;
    } = { labDetailsDto: undefined, radiologyDetailsDto: undefined };

    if (Boolean(edit)) {
      if (formType == "radiology") {
        params = {
          fromVerification,
          radiologyDetailsDto: prepareRadiologyPayload({
            ...edit,
            ...data,
            insDiscount: insDiscount.current,
            encounterId,
            paymentMode: patientData.pmaster.paymentMode,
            isPackage: 0,
            insuranceCoverage: Number(isManualCoverage),
            fromVerification,
            actualPatshare,
          }),
        };
      } else if (formType == "lab") {
        params = {
          fromVerification,
          labDetailsDto: prepareLabPayload({
            ...edit,
            ...data,
            insDiscount: insDiscount.current,
            encounterId,
            paymentMode: patientData.pmaster.paymentMode,
            isPackage: 0,
            fromVerification,
            insuranceCoverage: Number(isManualCoverage),
            actualPatshare,
          }) as LabType,
        };
      }
    } else {
      if (formType == "radiology") {
        params = {
          fromVerification,
          radiologyDetailsDto: prepareRadiologyPayload({
            ...data,
            insDiscount: insDiscount.current,
            encounterId,
            paymentMode: patientData.pmaster.paymentMode,
            isPackage: 0,
            fromVerification,
            insuranceCoverage: Number(isManualCoverage),
            actualPatshare,
          }),
        };
      } else if (formType == "lab") {
        params = {
          fromVerification,
          labDetailsDto: prepareLabPayload({
            ...edit,
            ...data,
            insDiscount: insDiscount.current,
            encounterId,
            paymentMode: patientData.pmaster.paymentMode,
            isPackage: 0,
            fromVerification,
            insuranceCoverage: Number(isManualCoverage),
            actualPatshare,
          }) as LabType,
        };
      }
    }

    // if (
    //   fromVerification &&
    //   Boolean(data.insuranceCoverage && data.isExcluded == 0)
    // ) {
    //   if (
    //     Number(data.Rate) * Number(data.Quantity) !=
    //     Number(data.amount) + Number(data.patientshare)
    //   ) {
    //     showSnackbar({
    //       message: "Sum of Amount and patient share is not match with Rate",
    //       open: true,
    //       variant: "info",
    //       duration: 3000,
    //     });
    //   } else {
    //     saveActivity(params);
    //   }
    // } else {
    saveActivity(params);
    // }
    console.log(params)
  };

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    searchActiviy(buildActivitySearchParams(value));
  };

  const debounceSearch = debounce(handleSearch, 500);

  useEffect(() => {
    searchActiviy(buildActivitySearchParams(""));
  }, []);

  useEffect(() => {
    if (Boolean(edit)) {
      const editIsExclude = Boolean(edit?.isExcluded);
      const editApproval = Boolean(edit?.approvalRequired);
      reset({
        ...edit,
        [investigationForm.Rate.name]: edit?.Rate || "0",
        [investigationForm.patientShare.name]: edit?.patientshare || "0",
        [investigationForm.amount.name]: edit?.amount || "0",
        createdDate: edit?.createdDate ? dayjs(edit?.createdDate) : null,
      });
      if (patientData.pmaster.paymentMode == 1) {
        setCheckboxChecked({
          approval: editIsExclude,
          exclude: editApproval,
        });
      } else {
        setCheckboxChecked({
          approval: true,
          exclude: true,
        });
      }
      if (
        patientData.pmaster.paymentMode == 1 &&
        edit?.cpt?.insCoverage == 1 &&
        !editIsExclude
      ) {
        Boolean(page != "verification") &&
          // !fromVerification &&
          edit?.cpt?.insCoverage == 1 &&
          fetchRate({
            cptId: edit?.cpt?.cptId as number,
            encounter: parseInt(encounterId as string),
            cptGroupId: edit?.cpt?.cptGroupId as number,
            paymentMode: patientData.pmaster.paymentMode,
          });
      }
      setIsManualCoverage(Number(edit?.cpt?.insCoverage));
    }

    if (Boolean(radiologyEdit)) {
      // isFetchRate = true;
      reset({
        ...radiologyEdit,
        [investigationForm.Rate.name]: radiologyEdit?.Rate || "0",
        [investigationForm.patientShare.name]:
          radiologyEdit?.patientshare || "0",
        [investigationForm.amount.name]: radiologyEdit?.amount || "0",
        createdDate: radiologyEdit?.createdDate
          ? dayjs(radiologyEdit?.createdDate)
          : null,
      });
      if (
        patientData.pmaster.paymentMode == 1 &&
        radiologyEdit?.cpt?.insCoverage == 1 &&
        !radiologyEdit.isExcluded
      ) {
        // !fromVerification &&
        radiologyEdit?.cpt?.insCoverage == 1 &&
          fetchRate({
            cptId: radiologyEdit?.cpt?.cptId as number,
            encounter: parseInt(encounterId as string),
            cptGroupId: radiologyEdit?.cpt?.cptGroupId as number,
            paymentMode: patientData.pmaster.paymentMode,
          });
      }
      setIsManualCoverage(Number(radiologyEdit?.cpt?.insCoverage));
    }
  }, [edit]);

  return (
    <div>
      <CustomModal
        handleClose={() => {
          reset({
            ...getValues(),
            [investigationForm.isExcluded.name]: false,
            [investigationForm.approvalRequired.name]: false,
          });
          setCheckboxChecked({
            approval: false,
            exclude: false,
          });

          setShow(false);
        }}
        title="Fetch cash rate"
        open={show}
        setOpen={setShow}
      >
        <div className="w-[40vw]">
          <div className="h-[10dvh] p-4">
            <Typography>Do you want to fetch cash rate ?</Typography>
          </div>
          <div className="p-3 flex justify-end gap-3 border-t">
            <Button
              color="error"
              onClick={() => {
                setShow(false);
                reset({
                  ...getValues(),
                  [investigationForm.isExcluded.name]: false,
                  [investigationForm.approvalRequired.name]: false,
                });
                setCheckboxChecked({
                  approval: false,
                  exclude: false,
                });
              }}
            >
              no
            </Button>
            <Button onClick={handleYesClick}>yes</Button>
          </div>
        </div>
      </CustomModal>
      <form onSubmit={handleSubmit(onsubmit)}>
        <div className="grid grid-cols-10 gap-3 p-2">
          <div
            className={
              fromVerification
                ? "col-span-full grid grid-cols-12"
                : "col-span-full"
            }
          >
            <div className={fromVerification ? "col-span-10" : ""}>
              <CustomFormField
                control={control}
                options={dropdowData?.response || []}
                loading={activityLoading}
                {...investigationForm.cptItem}
                fieldProps={{
                  ...investigationForm.cptItem.fieldProps,
                  onChange: debounceSearch,
                  sx: { borderTopRightRadius: 0, borderBottomRightRadius: 0 },
                }}
                autocompleteProps={{
                  ...investigationForm.cptItem.autocompleteProps,
                  open: cptListOpen,
                  onOpen: () => setCptListOpen(true),
                  onClose: () => setCptListOpen(false),
                  disableClearable: Boolean(edit),
                  disabled: Boolean(edit) || Boolean(radiologyEdit),
                  renderOption: (props, option: InvestigationDropDownType) =>
                    renderCptOptionListItem(
                      props,
                      option,
                      <div className="w-full grid grid-cols-12 gap-2 pe-2">
                        <div className="col-span-2 flex justify-start items-start gap-1">
                          <div className="w-5">
                            {Boolean(option.insCoverage) && (
                              <VerifiedUserIcon
                                color="success"
                                sx={{ fontSize: "1.2rem" }}
                              />
                            )}
                          </div>
                          <strong>Code : </strong>
                          <Typography>{option.cptCode}</Typography>
                        </div>
                        <div className="col-span-10 flex border-s-2 ps-2 gap-1 items-center">
                          <strong>Name : </strong>
                          <ListItemText primary={option.cptName} />
                        </div>
                      </div>,
                    ),
                }}
                rules={{ ...investigationForm.cptItem.rules, onChange }}
              />
            </div>
            <div
              className={
                Boolean(fromVerification && isManualCoverage == 1)
                  ? "flex justify-center items-center rounded rounded-s-none border border-s-0 col-span-2"
                  : "hidden"
              }
            >
              <VerifiedUserIcon color="success" />
            </div>
            <div
              className={
                Boolean(
                  fromVerification &&
                  (isManualCoverage == 0 || isManualCoverage == 2),
                )
                  ? "flex justify-end rounded rounded-s-none border border-s-0 col-span-2"
                  : "hidden"
              }
            >
              <CustomFormField
                control={control}
                {...investigationForm.insuranceCoverage}
                checkboxProps={{ label: "", disabled: !Boolean(selectedCpt) }}
                rules={{
                  ...investigationForm.insuranceCoverage.rules,
                  onChange: (e) => {
                    setValue(investigationForm.amount.name, 0);
                    setValue(investigationForm.patientShare.name, 0);
                    if (e.target.value) {
                      setValue(investigationForm.cptItem.name, {
                        ...selectedCpt,
                        insCoverage: 1,
                      });
                      setCheckboxChecked({
                        approval: false,
                        exclude: true,
                      });
                      setIsManualCoverage(2);
                    } else {
                      setValue(investigationForm.cptItem.name, {
                        ...selectedCpt,
                        insCoverage: 0,
                      });
                      setValue(investigationForm.approvalRequired.name, 0);
                      setValue(investigationForm.isExcluded.name, 0);
                      setCheckboxChecked({
                        approval: true,
                        exclude: true,
                      });
                      setIsManualCoverage(0);
                    }
                  },
                }}
              />
            </div>
          </div>
          <div className="">
            <CustomFormField
              control={control}
              {...investigationForm.Rate}
              fieldProps={{
                ...investigationForm.Rate.fieldProps,
                InputProps: {
                  endAdornment: (
                    <InputAdornment position="end">
                      {fetchRateLoading && <CircularProgress size={18} />}
                    </InputAdornment>
                  ),
                },
              }}
              rules={{ ...investigationForm.Rate.rules, onChange }}
            />
          </div>
          <div className="col-span-3 grid grid-cols-2 gap-1">
            <CustomFormField
              control={control}
              {...investigationForm.Quantity}
              rules={{ ...investigationForm.Quantity.rules, onChange }}
              fieldProps={{
                ...investigationForm.Quantity.fieldProps,
                InputProps: {
                  endAdornment: (
                    <InputAdornment position="end">
                      {fetchPatientShareLoading && (
                        <CircularProgress size={18} />
                      )}
                    </InputAdornment>
                  ),
                },
              }}
            />
          <div className="flex flex-col">
            <div className="flex">
              <CustomFormField
                control={control}
                element="input"
                name="discount"
                fieldProps={{
                  label: "Discount",
                  type: "number",
                  onKeyDown: (e: any) => {
                    if (e.key === "-" || e.key === "e" || e.key === "+") {
                      e.preventDefault();
                    }
                  },
                  onInput: (e: any) => {
                    let val = Number(e.target.value);
                    const discountType = getValues("discountType") || "Percentage";
                    if (val < 0) {
                      e.target.value = "0";
                    } else if (discountType === "Percentage" && val > 100) {
                      e.target.value = "100";
                    }
                  },
                  inputProps: { min: 0 },
                  sx: {
                    fontSize: "0.875rem",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                    },
                    "&.MuiOutlinedInput-root": {
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                    },
                    "& .MuiSelect-select": {
                      paddingX: "4px",
                    },
                    "& .MuiFormHelperText-root": {
                      display: "none",
                    },
                  },
                }}
                rules={{ required: false, onChange }}
              />
              <Controller
                control={control}
                name="discountType"
                rules={{ required: false, onChange }}
                render={({
                  field: { ref, onChange, value = null, ...field },
                }) => (
                  <Select
                    {...field}
                    size="small"
                    value={value}
                    onChange={onChange}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{
                      fontSize: "0.875rem",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        borderLeft: "none",
                      },
                      "&.MuiOutlinedInput-root": {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        borderLeft: "none",
                      },
                      "& .MuiSelect-select": {
                        paddingX: "4px",
                        borderLeft: "none",
                      },
                    }}
                  >
                    <MenuItem value={"Percentage"}><PercentIcon fontSize="small" /></MenuItem>
                    <MenuItem value={"Amount"}>
                    {/* <AttachMoneyIcon fontSize="small" /> */}
                    AMT.
                    </MenuItem>
                  </Select>
                )}
              />
            </div>
          </div>
          </div>
          <div className="col-span-2">
            <CustomFormField control={control} {...investigationForm.amount} />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...investigationForm.patientShare}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...investigationForm.outHouse}
            />
          </div>
          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...investigationForm.approvalRequired}
              rules={{
                ...investigationForm.approvalRequired.rules,
                onChange: handleApprovalChange,
              }}
              checkboxProps={{
                label: "",
                disabled: Boolean(patientData.pmaster.paymentMode)
                  ? Boolean(selectedCpt?.insCoverage)
                    ? checkboxChecked.approval
                    : true
                  : true,
                value: checkboxChecked.approval,
              }}
            />
          </div>

          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...investigationForm.isExcluded}
              fieldProps={{ ...investigationForm.isExcluded.fieldProps }}
              checkboxProps={{
                label: "",
                disabled: Boolean(patientData.pmaster.paymentMode)
                  ? Boolean(selectedCpt?.insCoverage)
                    ? checkboxChecked.exclude
                    : true
                  : true,
                value: checkboxChecked.exclude,
              }}
              rules={{
                ...investigationForm.isExcluded.rules,
                onChange: handleExcludeChange,
              }}
            />
          </div>

          <div className="col-span-2">
            <CustomFormField
              control={control}
              {...investigationForm.IsPerfomed}
            />
          </div>

          <div className="col-span-2">
            <CustomFormField control={control} {...investigationForm.Reason} />
          </div>

          <div className="col-span-2">
            <CustomFormField control={control} {...investigationForm.Remark} />
          </div>

          <div
            className={
              fromVerification
                ? "col-span-full flex flex-col md:flex-row gap-4 justify-end items-center bg-blue-50/50 p-3 rounded-md mt-2 border border-blue-100"
                : "col-span-full flex flex-col md:flex-row gap-4 justify-end items-center p-3 rounded-md mt-2"
            }
          >
            {fromVerification && (
              <div className="flex gap-3 items-center mr-auto">
                <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded shadow-sm border border-gray-100">
                  <span className="text-xs font-semibold text-gray-500 tracking-wider">
                    START TIME:
                  </span>
                  <span className="text-sm font-medium text-gray-800">
                    {patientData?.encounter?.startTime
                      ? moment(patientData?.encounter?.startTime).format(
                        "DD-MM-YYYY hh:mm A",
                      )
                      : "-"}
                  </span>
                </div>
                <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded shadow-sm border border-gray-100">
                  <span className="text-xs font-semibold text-gray-500 tracking-wider">
                    END TIME:
                  </span>
                  <span className="text-sm font-medium text-gray-800">
                    {patientData?.encounter?.endTime
                      ? moment(patientData?.encounter?.endTime).format(
                        "DD-MM-YYYY hh:mm A",
                      )
                      : "-"}
                  </span>
                </div>
              </div>
            )}

            <div className="flex items-center gap-3">
              <div className={fromVerification ? "" : "hidden"}>
                <CustomDateField
                  start={patientData?.encounter?.startTime}
                  end={patientData?.encounter?.endTime}
                  control={control}
                  name="createdDate"
                />
              </div>
              <Button
                type="submit"
                color="success"
                variant="contained"
                disableElevation
                disabled={activitySaveLoading}
                endIcon={
                  activitySaveLoading && (
                    <CircularProgress
                      size={18}
                      sx={(theme) => ({
                        color: theme.palette.background.paper,
                      })}
                    />
                  )
                }
              >
                Save
              </Button>
              <Button
                color="error"
                onClick={() => {
                  close && close();
                  if (Boolean(edit)) {
                    setEdit(null);
                  }
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default InvestigationForm;
